import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SoundService {
  private audio = new Audio();
  constructor() { }

  playSound(): void {
    this.audio.src = 'assets/sound/newOrder.mp3';
    this.audio.loop = false;
    this.audio.load();
    this.audio.play().then();
  }

  playSoundLoop(): void {
    this.audio.src = 'assets/sound/newOrder.mp3';
    this.audio.loop = true;
    this.audio.load();
    this.audio.play().then();
  }

  stopSound(): void {
    this.audio.pause();
    this.audio.currentTime = 0;
    this.audio.loop = false;
  }
}
